<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Способы оплаты"
    >
      <v-dialog v-model="editDialog">
        <template #activator="{ on, attrs }">
          <v-btn
            color="red"
            dark
            class="mb-2"
            v-bind="attrs"
            v-on="on"
          >
            Новый способ оплаты
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Редактирование способа оплаты</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="12">
                <v-text-field
                  v-model="editedItem.name"
                  label="Название"
                />
                <v-checkbox
                  v-model="editedItem.isFreeDelivery"
                  label="Бесплатная доставка"
                ></v-checkbox>
                <v-select
                  v-model="editedItem.type"
                  :items="typesList"
                  label="Тип"
                  single-line
                />
                <v-select
                  v-model="editedItem.status"
                  :items="statusList"
                  label="Статус"
                  single-line
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="closeEdit">
              Отмена
            </v-btn>
            <v-btn color="blue darken-1" text @click="save">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        :loading="$apollo.loading"
        loading-text="Загрузка..."
        :headers="headers"
        :items="data"
        :server-items-length="totalCount"
        :options.sync="options"
      >
        <template #body.prepend>
          <tr>
            <td></td>
            <td></td>
            <td>
              <v-select
                v-model="filterType"
                :items="typesList"
                clearable
              />
            </td>
            <td>
              <v-select
                v-model="filterStatus"
                :items="statusList"
                clearable
              />
            </td>
          </tr>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            transition="dialog-bottom-transition"
            width="500"
            :value="deleteDialog === item.id"
            @input="toggleDeleteDialog($event, item.id)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Вы точно хотите удалить запись?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = null">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item.id)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template #item.status="{ item }">
          {{ getStatus(item) }}
        </template>
        <template #item.type="{ item }">
          {{ getType(item) }}
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { createPayment, deletePayment, getPayments, updatePayment } from '@/graphql/payments'
import { startCase } from 'lodash-es'

export default {
  name: 'PaymentsList',
  components: {
  },
  layout: 'dashboard',
  apollo: {
    payments: {
      query: getPayments,
      variables () {
        const filter = {}
        if (this.filterStatus) {
          filter.status = this.filterStatus
        }
        if (this.filterType) {
          filter.type = this.filterType
        }
        return {
          filter,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      result ({ data }) {
        if (data?.payments?.data) {
          this.data = data.payments.data
          this.totalCount = data.payments.totalCount
        }
      },
      update: data => data?.payments?.data
    }
  },
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        multiSort: false
      },
      totalCount: 0,
      deleteDialog: false,
      dialog: false,
      editDialog: false,
      newItem: true,
      filter: [],
      filterName: '',
      filterType: '',
      filterStatus: 'ACTIVE',
      editedItem: {},
      data: [],
      statusList: [
        { value: 'ACTIVE', text: 'Активно' },
        { value: 'NOT_ACTIVE', text: 'Не активно' }
      ],
      typesList: [
        { value: 'CASH', text: 'Наличными' },
        { value: 'ONLINE', text: 'Онлайн' }
      ],
      headers: [
        ['id', 'Id'],
        ['name', 'Название'],
        ['type', 'Тип'],
        ['status', 'Статус'],
        ['actions', null]
      ]
          .map((colTitle) => {
            const [value, text] = Array.isArray(colTitle)
                ? colTitle
                : [colTitle, startCase(colTitle)]

            return {
              value,
              text,
              sortable: false
            }
          }),
      rules: {
        required: value => !!value || 'Обязательное поле.'
      }
    }
  },
  computed: {
  },
  watch: {
    dialog (val) {
      if (!val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    },
    editDialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    getType (item) {
      const ret = this.typesList.filter(row => row.value === item.type)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.type
    },
    toggleDeleteDialog (value, slug) {
      this.deleteDialog = value
          ? slug
          : null
    },
    save () {
      const saveData = {
        name: this.editedItem.name,
        isFreeDelivery: this?.editedItem?.isFreeDelivery ?? false,
        type: this.editedItem.type,
        status: this.editedItem.status
      }
      if (this.newItem) {
        this.$apollo
            .mutate({
              mutation: createPayment,
              variables: {
                input: saveData
              }
            })
            .then((data) => {
              this.$apollo.queries.payments.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      } else {
        const id = this.editedItem.id
        this.$apollo
            .mutate({
              mutation: updatePayment,
              variables: {
                id,
                input: saveData
              }
            })
            .then((data) => {
              this.$apollo.queries.payments.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      }
      this.closeEdit()
      this.editedItem = []
    },
    deleteItem (id) {
      this.$apollo
          .mutate({
            mutation: deletePayment,
            variables: {
              id
            }
          })
          .then((data) => {
            this.$apollo.queries.payments.refetch()
            this.deleteDialog = null
          })
          .catch((error) => {
            console.error(error)
          })
    },
    editItem (item) {
      this.newItem = false
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
    },
    close () {
      this.dialog = false
    },
    closeEdit () {
      this.editDialog = false
    },
    formatDate (timestamp) {
      const date = new Date(timestamp)
      return date.form
    }
  }
}
</script>

<style scoped>

</style>
